module.exports = __webpack_public_path__ + "img/live_event.4ae2e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/events-page/live_event.png
// module id = 1589
// module chunks = 1